import { createModalStore } from '@/shared/lib/modal';

export const useScreenRecordPromoBannerStore = createModalStore();
